import { SpinnerEventBus } from './EventBus/EventBus';

export const enum SpinnerEvents {
  Show = 'show',
  Hide = 'hide',
}

export const showLoadingSpinner = () => {
  SpinnerEventBus.emit(SpinnerEvents.Show);
};

export const hideLoadingSpinner = () => {
  SpinnerEventBus.emit(SpinnerEvents.Hide);
};
